import React from "react";
import { each, get, isEmpty } from "lodash";
import { getWorkOtherList, postRequestWorkOther } from "../../apis/work-schedule/other-work";
import { getApprobalListByParam } from "../../utils/approval";
import { dateToFormat, dateToViewFormat, formatHourSecond, getDateRangeList, getDay, getFormatHour } from "../../utils/date";
import DataComponent from "../../components/DataComponent";
import systemAlert from "../../utils/systemAlert";
import { taskRequest } from "../../utils/task";
const getTask = async ({ mode, defaultData }) => {


  const workOtherListData = await getWorkOtherList({
    "search": {
      "workName": "%%",
      "isActive": true
    },
    "order": [
      {
        "idx": "asc"
      },
      {
        "workTimeInSeconds": "desc"
      }
    ],
    "offset": 0,
    "limit": 100
  });
  const workOtherList = [
    ...get(workOtherListData, 'data.works', [])
      .map(item => ({ label: item.workName, value: item.workIdx }))
  ];
  if (isEmpty(workOtherList)) {
    systemAlert('신청 가능한 기타근무가 없습니다.\n담당자에게 문의해주세요.');
    taskRequest(null);
  }
  const defaultWorkOther = get(workOtherList, '[0].value');

  const getTitle = (form = { dates: [getDay(), getDay()] }) => {
    const workOther = workOtherList.find(f => f.value === (+form.otherWorkIdx || null)) || workOtherList[0];
    return `[${workOther.label}] ${form.dates[0]} ~ ${form.dates[1]} 기타 근무 요청`;
  };

  const fields = [
    {
      title: "근무유형",
      key: "otherWorkIdx",
      type: "select",
      width: 400,
      options: {
        list: workOtherList
      },
      onChanged: ({ form, onChange }) => {
        if (mode !== "create") return;
        const title = getTitle(form);
        onChange({ target: { name: "title", value: title } });
      }
    },
    {
      title: "근무기간",
      key: "dates",
      type: "datepicker",
      detail: 'component',
      options: {
        mode: "range",
        dateFormat: "Y-m-d",
      },
      required: true,
      component: ({ form }) => {
        const start = form.dates[0];
        const end = form.dates[1];
        return <>{dateToViewFormat(start)} ~ {dateToViewFormat(end)}</>;
      },
      onChanged: ({ form, onChange }) => {
        if (mode !== "create") return;
        const title = getTitle(form);
        onChange({ target: { name: "title", value: title } });
      }
    },
    {
      title: "근무시간",
      key: "times",
      type: "timepicker",
      isRange: true,
      required: true,
      detail: 'component',
      component: ({ form }) => {
        const start = form.dates[0];
        const end = form.dates[1];
        return <>{getFormatHour(start)} ~ {getFormatHour(end)}</>;
      },

    },
    {
      title: "휴게시간",
      key: "restTimes",
      isHide: ({ form }) => {
        return isEmpty(form.restTimes);
      },
      titlestyle: {
        verticalAlign: 'top',
      },
      component: ({ form, onChange }) => {
        if (mode === 'create') {
          return form.restTimes.map((times, idx) => {
            return <div key={idx} className="m-b-5">
              <DataComponent field={{
                type: 'timepicker',
                isRange: true,
                key: `restTimes[${idx}]`,
                onChange,
              }}></DataComponent>
            </div>;
          });
        } else {
          const restTimes = form.restTimes;
          return <>
            {restTimes.map((dates, idx) => <p key={idx} className="mb5">
              {getFormatHour(dates.startTime)} ~ {getFormatHour(dates.endTime)}
            </p>)}
          </>;
        }
      }
    },
    {
      title: " ",
      label: "휴게시간 추가",
      type: "button",
      isHide: mode !== 'create',
      className: "full-width ",
      color: 'gray-line',
      onClick: ({ form, onChange }) => {
        form.restTimes.push({
          form: "", to: ""
        });
        onChange({
          restTimes: form.restTimes
        });

      }
    },
    {
      title: "제목",
      key: "title",
      type: "input",
      required: true,
    },
    {
      title: "사유",
      key: "description",
      type: "textarea",
      required: true,
    },
    {
      title: "첨부파일",
      key: "uploadFiles",
      type: "dropzone",
      changeDefaultFile: true,
    },
  ];

  const defaultForm = {
    otherWorkIdx: get(defaultData, 'data.workRequest.otherWorkTitle', defaultWorkOther),
    dates: [
      get(defaultData, 'data.workRequest.workStartTime', getDay()),
      get(defaultData, 'data.workRequest.workEndTime', getDay()),
    ],
    times: {
      from: defaultData?.data?.workRequest?.workEndTime ? dateToFormat(defaultData?.data?.workRequest?.workStartTime, formatHourSecond) : '',
      to: defaultData?.data?.workRequest?.workEndTime ? dateToFormat(defaultData?.data?.workRequest?.workEndTime, formatHourSecond) : '',
    },
    title: get(defaultData, 'data.workRequest.title', getTitle()),
    description: get(defaultData, 'data.workRequest.description', ""),
    uploadFiles: get(defaultData, 'data.vacationRequest.uploadFiles', []),
    restTimes: get(defaultData, 'data.workRequest.requestSchedule[0].restTimes', []),
  };

  const create = (form) => {
    const dayRange = getDateRangeList(form.dates[0], form.dates[1]);
    const params = {
      otherWorkIdx: form.otherWorkIdx,
      title: form.title,
      description: form.description,
      otherWorkSchedule: dayRange.map(day => ({
        workStartTime: `${day} ${form.times.from}`,
        workEndTime: `${day} ${form.times.to}`,
        // restTimes: form.restTimes.map((date) => {
        //   debugger
        //   return
        // })
        restTimes: form.restTimes.map((date) => ({
          startTime: `${day} ${date.from}`,
          endTime: `${day} ${date.to}`
        })) // TODO 휴게시간 추가 필요
      })),
      uploadFiles: form.uploadFiles,
      apprList: getApprobalListByParam(form.approverEmployees, form.referenceEmployees),
    };

    //console.log(params)
    return postRequestWorkOther(params);
  };

  const validate = (form) => {
    let errors = {};
    if (form.times.from >= form.times.to) {
      errors['times'] = '종료시간은 시작시간보다 작거나 같을 수 없습니다.';
    }
    if (!form.times.to) {
      errors['times'] = '종료시간은 필수입니다.';
    }
    if (!form.times.from) {
      errors['times'] = '시작시간은 필수입니다.';
    }
    if (!isEmpty(form.restTimes)) {
      each(form.restTimes, (restTimes) => {
        if (restTimes.from >= restTimes.to) {
          errors['restTimes'] = '종료시간은 시작시간보다 작거나 같을 수 없습니다.';
        }
        if (!restTimes.to) {
          errors['restTimes'] = '종료시간은 필수입니다.';
        }
        if (!restTimes.from) {
          errors['restTimes'] = '시작시간은 필수입니다.';
        }
      });
    }
    return errors;
  };
  return {
    fields, defaultForm, create, validate
  };

};

export default getTask;